module.exports = __webpack_public_path__ + "0a8c6bf80e0f4c2d3cb5c7d08cbe01a5.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/icons/plus.png
// module id = ZdBq
// module chunks = 22